import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

export const generatePDFIIP = async ({userLevel, heading1, heading2, heading3, heading4,heading5, headerEnglishColumns, pdfData, width, PDFFileName }) => {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    let h1='';
    let h2='';
    let h3='';
    let h4='';
    let h5='';
    let pageSizeWidth=20.14 * 80;
    let pageSizeHeight=141.63 * 72;


    if (userLevel === "DISTRICT LEVEL") {
        h1= [{ text: heading1, colSpan: 2, alignment: 'right' }, {}];
        h2= [{ text: heading2, style: 'header', colSpan: 2, alignment: 'center' }, {}];
        h3= [{ text: heading3, style: 'subheader_one', colSpan: 2, alignment: 'center' }, {}];
        h4=[{ text: heading4, style: 'subheader_one', colSpan: 2, alignment: 'center' }, {}];
        h5 =[{ text: heading5,style: 'subheader_two', colSpan: 2, alignment: 'center' }, {}];
         pageSizeWidth=20.14 * 80;
         pageSizeHeight=100.63 * 72;

    } 
    if(userLevel === "DIVISION LEVEL"){
        h1= [{ text: heading1, colSpan: 10, alignment: 'right' }, {}, {}, {}, {}, {}, {}, {}, {}, {}];
        h2= [{ text: heading2, style: 'header', colSpan: 10, alignment: 'center' }, {}, {}, {}, {}, {}, {}, {}, {}, {}];
        h3= [{ text: heading3, style: 'subheader_one', colSpan: 10, alignment: 'center' }, {}, {}, {}, {}, {}, {}, {}, {}, {}];
        h4=[{ text: heading4, style: 'subheader_one', colSpan: 10, alignment: 'center' }, {}, {}, {}, {}, {}, {}, {}, {}, {}];
        h5 =[{ text: heading5,style: 'subheader_two', colSpan: 10, alignment: 'center' }, {}, {}, {}, {}, {}, {}, {}, {}, {}];

    }

    if(userLevel === "HEAD QUARTER"){
        h1= [{ text: heading1, colSpan: 11, alignment: 'right' }, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}];
        h2= [{ text: heading2, style: 'header', colSpan: 11, alignment: 'center' }, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}];
        h3= [{ text: heading3, style: 'subheader_one', colSpan: 11, alignment: 'center' }, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}];
        h4=[{ text: heading4, style: 'subheader_one', colSpan: 11, alignment: 'center' }, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}];
        h5 =[{ text: heading5,style: 'subheader_two', colSpan: 11, alignment: 'center' }, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}];

     }

    const documentDefinition = {
        pageSize: {
            width:pageSizeWidth, // Convert inches to points (1 inch = 72 points)
            height: pageSizeHeight, // Convert inches to points (1 inch = 72 points)
        },
        pageOrientation: 'portrait',
        content: [
            {
                table: {
                    headerRows: 1,
                    widths: width,
                    body: [
                        h1,h2,h3,h4,h5,
                        [...headerEnglishColumns.map((text) => ({
                            text: text,
                            alignment: 'center',
                            bold: true,
                            fontSize: 15,
                        }))],
                        ...pdfData.map(row => row.map((cell) => ({
                            text: cell || '',
                            fontSize: 12,
                            bold: true,
                            alignment: 'center',
                        }))),
                    ],
                },
            },
        ],
        styles: {
            header: {
                fontSize: 20,
                // bold: true,
                alignment: 'center',
                color: 'red'
            },
            subheader_one: {
                fontSize: 15,
                alignment: 'center',
                color: 'black',
            },
            subheader_two: {
                fontSize: 13,
                // bold: true,
                alignment: 'center',
                color: 'black',
            }
        },
    };

    pdfMake.createPdf(documentDefinition).download(PDFFileName);
};



